// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetAdminAutoCreateEmailTemplateExportTemplatesData, GetAdminAutoCreateEmailTemplateExportTemplatesErrors, GetAdminAutoCreateEmailTemplateExportTemplatesResponses, GetAdminAutoCreateEmailTemplateGetData, GetAdminAutoCreateEmailTemplateGetErrors, GetAdminAutoCreateEmailTemplateGetResponses, GetAdminAutoCreateEmailTemplateListData, GetAdminAutoCreateEmailTemplateListResponses, GetAdminAutoCreateEmailTemplateListVariablesData, GetAdminAutoCreateEmailTemplateListVariablesResponses, GetAdminAutoCreateEmailTemplatePreviewPreviewData, GetAdminAutoCreateEmailTemplatePreviewPreviewErrors, GetAdminAutoCreateEmailTemplatePreviewPreviewResponses, GetAdminClaimtypeGetData, GetAdminClaimtypeGetResponses, GetAdminEmailSignatureGetData, GetAdminEmailSignatureGetResponses, GetAdminEmailTemplateExportTemplatesData, GetAdminEmailTemplateExportTemplatesErrors, GetAdminEmailTemplateExportTemplatesResponses, GetAdminEmailTemplateGetData, GetAdminEmailTemplateGetErrors, GetAdminEmailTemplateGetResponses, GetAdminEmailTemplateListData, GetAdminEmailTemplateListResponses, GetAdminEmailTemplateListVariablesData, GetAdminEmailTemplateListVariablesResponses, GetAdminFnolCategoryGetConfirmationEmailTemplateData, GetAdminFnolCategoryGetConfirmationEmailTemplateErrors, GetAdminFnolCategoryGetConfirmationEmailTemplateResponses, GetAdminFnolCategoryListData, GetAdminFnolCategoryListResponses, GetAdminFnolCategoryTemplateListVariablesData, GetAdminFnolCategoryTemplateListVariablesResponses, GetAdminFnolExportAllTemplatesData, GetAdminFnolExportAllTemplatesResponses, GetAdminFnolExportTemplatesData, GetAdminFnolExportTemplatesErrors, GetAdminFnolExportTemplatesResponses, GetAdminFnolGetAllQuestionsData, GetAdminFnolGetAllQuestionsResponses, GetAdminFnolGetCompletedData, GetAdminFnolGetCompletedResponses, GetAdminFnolGetData, GetAdminFnolGetErrors, GetAdminFnolGetOngoingData, GetAdminFnolGetOngoingResponses, GetAdminFnolGetRejectedData, GetAdminFnolGetRejectedResponses, GetAdminFnolGetResponses, GetAdminFnolGetTemplateSummariesData, GetAdminFnolGetTemplateSummariesResponses, GetAdminFnolTemplateGetData, GetAdminFnolTemplateGetErrors, GetAdminFnolTemplateGetResponses, GetAdminFossListIncidentTypesData, GetAdminFossListIncidentTypesResponses, GetAdminFossListMarketCodesData, GetAdminFossListMarketCodesResponses, GetAdminGsrListInsuranceCompaniesData, GetAdminGsrListInsuranceCompaniesResponses, GetAdminGsrListTypesData, GetAdminGsrListTypesResponses, GetAdminPartnerSettingsGetCurrentData, GetAdminPartnerSettingsGetCurrentResponses, GetAdminSuggestorsGetAllSuggestorsData, GetAdminSuggestorsGetAllSuggestorsResponses, GetAdminSuggestorsGetSuggestorErrorsData, GetAdminSuggestorsGetSuggestorErrorsErrors, GetAdminSuggestorsGetSuggestorErrorsResponses, GetAdminUserSettingsGetCurrentData, GetAdminUserSettingsGetCurrentResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyData, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyErrors, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyData, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyErrors, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateData, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateErrors, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateResponses, GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateData, GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateErrors, GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateResponses, GetClaimcaseByKeyByClaimcaseKeyGetData, GetClaimcaseByKeyByClaimcaseKeyGetErrors, GetClaimcaseByKeyByClaimcaseKeyGetResponses, GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsData, GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsErrors, GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsResponses, GetClaimcaseGetClosedData, GetClaimcaseGetClosedErrors, GetClaimcaseGetClosedResponses, GetClaimcaseGetExternalData, GetClaimcaseGetExternalErrors, GetClaimcaseGetExternalResponses, GetClaimcaseGetOpenData, GetClaimcaseGetOpenErrors, GetClaimcaseGetOpenResponses, GetClaimcaseListRefsData, GetClaimcaseListRefsResponses, GetCognitoAdminGetUserByUsernameData, GetCognitoAdminGetUserByUsernameErrors, GetCognitoAdminGetUserByUsernameResponses, GetCognitoAdminListClaimsHandlersData, GetCognitoAdminListClaimsHandlersResponses, GetFnolGetData, GetFnolGetErrors, GetFnolGetReportsData, GetFnolGetReportsResponses, GetFnolGetResponses, GetGetAllQuestionsData, GetGetAllQuestionsResponses, GetGetAllTasksData, GetGetAllTasksResponses, GetGetInvoiceRecipientsData, GetGetInvoiceRecipientsResponses, GetGetUnlabeledEmailsData, GetGetUnlabeledEmailsResponses, GetGmailConnectLinkData, GetGmailConnectLinkResponses, GetHealthCheckData, GetHealthCheckResponses, GetInboxRecentEmailsData, GetInboxRecentEmailsErrors, GetInboxRecentEmailsResponses, GetInboxUnhandledEmailsData, GetInboxUnhandledEmailsErrors, GetInboxUnhandledEmailsResponses, GetInfoData, GetInfoResponses, GetOauthCallbackByIntegrationData, GetOauthCallbackByIntegrationErrors, GetOauthCallbackByIntegrationResponses, GetPaymentGetFromOpenClaimcasesData, GetPaymentGetFromOpenClaimcasesResponses, GetPaymentGetRejectedData, GetPaymentGetRejectedResponses, GetPaymentGetScheduledData, GetPaymentGetScheduledResponses, GetPaymentGetUnsignedData, GetPaymentGetUnsignedResponses, GetPolicyByInsuranceHolderCompanyData, GetPolicyByInsuranceHolderCompanyDayData, GetPolicyByInsuranceHolderCompanyDayErrors, GetPolicyByInsuranceHolderCompanyDayResponses, GetPolicyByInsuranceHolderCompanyErrors, GetPolicyByInsuranceHolderCompanyResponses, GetPolicyByInsuranceHolderPersonData, GetPolicyByInsuranceHolderPersonDayData, GetPolicyByInsuranceHolderPersonDayErrors, GetPolicyByInsuranceHolderPersonDayResponses, GetPolicyByInsuranceHolderPersonErrors, GetPolicyByInsuranceHolderPersonResponses, GetPolicyByInsuredObjectCompanyData, GetPolicyByInsuredObjectCompanyDayData, GetPolicyByInsuredObjectCompanyDayErrors, GetPolicyByInsuredObjectCompanyDayResponses, GetPolicyByInsuredObjectCompanyErrors, GetPolicyByInsuredObjectCompanyResponses, GetPolicyByInsuredObjectPersonData, GetPolicyByInsuredObjectPersonDayData, GetPolicyByInsuredObjectPersonDayErrors, GetPolicyByInsuredObjectPersonDayResponses, GetPolicyByInsuredObjectPersonErrors, GetPolicyByInsuredObjectPersonResponses, GetPolicyByInsuredObjectVehicleData, GetPolicyByInsuredObjectVehicleDayData, GetPolicyByInsuredObjectVehicleDayErrors, GetPolicyByInsuredObjectVehicleDayResponses, GetPolicyByInsuredObjectVehicleErrors, GetPolicyByInsuredObjectVehicleResponses, GetPolicyByKeyData, GetPolicyByKeyDayData, GetPolicyByKeyDayErrors, GetPolicyByKeyDayResponses, GetPolicyByKeyErrors, GetPolicyByKeyResponses, GetPolicyGetByNumberDayData, GetPolicyGetByNumberDayErrors, GetPolicyGetByNumberDayResponses, GetReportBankTransactionData, GetReportBankTransactionResponses, GetReportClaimSummaryData, GetReportClaimSummaryResponses, GetReportCoverQuestionsData, GetReportCoverQuestionsResponses, GetReportFullTransactionData, GetReportFullTransactionErrors, GetReportFullTransactionResponses, GetReportKpiData, GetReportKpiErrors, GetReportKpiListData, GetReportKpiListResponses, GetReportKpiResponses, GetReportScheduledPaymentsData, GetReportScheduledPaymentsResponses, GetReportSebTransactionGetTransactionListData, GetReportSebTransactionGetTransactionListErrors, GetReportSebTransactionGetTransactionListResponses, GetReportSummaryData, GetReportSummaryResponses, GetReportTransactionData, GetReportTransactionErrors, GetReportTransactionResponses, GetSearchEmailData, GetSearchEmailErrors, GetSearchEmailResponses, GetSearchFreeTextData, GetSearchFreeTextErrors, GetSearchFreeTextResponses, GetSearchMatchingClaimcaseData, GetSearchMatchingClaimcaseErrors, GetSearchMatchingClaimcaseResponses, GetSearchPoliciesByInsuranceHolderData, GetSearchPoliciesByInsuranceHolderErrors, GetSearchPoliciesByInsuranceHolderResponses, GetSearchPoliciesByInsuredObjectData, GetSearchPoliciesByInsuredObjectErrors, GetSearchPoliciesByInsuredObjectResponses, GetSkadehubInboxData, GetSkadehubInboxErrors, GetSkadehubInboxResponses, GetSkadehubIncidentDetailsData, GetSkadehubIncidentDetailsErrors, GetSkadehubIncidentDetailsResponses, GetSkadehubIncidentLoginUrlData, GetSkadehubIncidentLoginUrlErrors, GetSkadehubIncidentLoginUrlResponses, GetSkadehubSuggestedCasesData, GetSkadehubSuggestedCasesErrors, GetSkadehubSuggestedCasesResponses, GetSkadehubUnlinkedData, GetSkadehubUnlinkedErrors, GetSkadehubUnlinkedResponses, PostAdminAutoCreateEmailTemplateChangeBodyData, PostAdminAutoCreateEmailTemplateChangeBodyErrors, PostAdminAutoCreateEmailTemplateChangeBodyResponses, PostAdminAutoCreateEmailTemplateChangeSubjectData, PostAdminAutoCreateEmailTemplateChangeSubjectErrors, PostAdminAutoCreateEmailTemplateChangeSubjectResponses, PostAdminAutoCreateEmailTemplateCreateData, PostAdminAutoCreateEmailTemplateCreateErrors, PostAdminAutoCreateEmailTemplateCreateResponses, PostAdminAutoCreateEmailTemplateDeleteData, PostAdminAutoCreateEmailTemplateDeleteErrors, PostAdminAutoCreateEmailTemplateDeleteResponses, PostAdminAutoCreateEmailTemplateImportTemplatesData, PostAdminAutoCreateEmailTemplateImportTemplatesErrors, PostAdminAutoCreateEmailTemplateImportTemplatesResponses, PostAdminAutoCreateEmailTemplateRenameData, PostAdminAutoCreateEmailTemplateRenameErrors, PostAdminAutoCreateEmailTemplateRenameResponses, PostAdminClaimtypeCopyData, PostAdminClaimtypeCopyErrors, PostAdminClaimtypeCopyResponses, PostAdminClaimtypeCreateData, PostAdminClaimtypeCreateErrors, PostAdminClaimtypeCreateResponses, PostAdminClaimtypeDeleteData, PostAdminClaimtypeDeleteErrors, PostAdminClaimtypeDeleteResponses, PostAdminClaimtypeMoveData, PostAdminClaimtypeMoveErrors, PostAdminClaimtypeMoveResponses, PostAdminClaimtypeUpdateDefaultReserveAmountData, PostAdminClaimtypeUpdateDefaultReserveAmountErrors, PostAdminClaimtypeUpdateDefaultReserveAmountResponses, PostAdminClaimtypeUpdateDescriptionData, PostAdminClaimtypeUpdateDescriptionErrors, PostAdminClaimtypeUpdateDescriptionResponses, PostAdminClaimtypeUpdateFossTypeData, PostAdminClaimtypeUpdateFossTypeErrors, PostAdminClaimtypeUpdateFossTypeResponses, PostAdminClaimtypeUpdateGsrTypeData, PostAdminClaimtypeUpdateGsrTypeErrors, PostAdminClaimtypeUpdateGsrTypeResponses, PostAdminClaimtypeUpdateInitialRecoveryExpectationData, PostAdminClaimtypeUpdateInitialRecoveryExpectationErrors, PostAdminClaimtypeUpdateInitialRecoveryExpectationResponses, PostAdminClaimtypeUpdateNameData, PostAdminClaimtypeUpdateNameErrors, PostAdminClaimtypeUpdateNameResponses, PostAdminEmailSignatureChangeData, PostAdminEmailSignatureChangeErrors, PostAdminEmailSignatureChangeResponses, PostAdminEmailTemplateChangeBodyData, PostAdminEmailTemplateChangeBodyErrors, PostAdminEmailTemplateChangeBodyResponses, PostAdminEmailTemplateChangeSubjectData, PostAdminEmailTemplateChangeSubjectErrors, PostAdminEmailTemplateChangeSubjectResponses, PostAdminEmailTemplateCreateData, PostAdminEmailTemplateCreateErrors, PostAdminEmailTemplateCreateResponses, PostAdminEmailTemplateCreateVariableData, PostAdminEmailTemplateCreateVariableErrors, PostAdminEmailTemplateCreateVariableResponses, PostAdminEmailTemplateDeleteData, PostAdminEmailTemplateDeleteErrors, PostAdminEmailTemplateDeleteResponses, PostAdminEmailTemplateDeleteVariableData, PostAdminEmailTemplateDeleteVariableErrors, PostAdminEmailTemplateDeleteVariableResponses, PostAdminEmailTemplateImportTemplatesData, PostAdminEmailTemplateImportTemplatesErrors, PostAdminEmailTemplateImportTemplatesResponses, PostAdminEmailTemplateRenameData, PostAdminEmailTemplateRenameErrors, PostAdminEmailTemplateRenameResponses, PostAdminEmailTemplateUpdateVariableData, PostAdminEmailTemplateUpdateVariableErrors, PostAdminEmailTemplateUpdateVariableResponses, PostAdminFnolCategoryChangeIncidentDayQueryData, PostAdminFnolCategoryChangeIncidentDayQueryErrors, PostAdminFnolCategoryChangeIncidentDayQueryResponses, PostAdminFnolCategoryChangeInsuranceHolderTypeData, PostAdminFnolCategoryChangeInsuranceHolderTypeErrors, PostAdminFnolCategoryChangeInsuranceHolderTypeResponses, PostAdminFnolCategoryChangeInsuredObjectTypeData, PostAdminFnolCategoryChangeInsuredObjectTypeErrors, PostAdminFnolCategoryChangeInsuredObjectTypeResponses, PostAdminFnolCategoryCreateData, PostAdminFnolCategoryCreateErrors, PostAdminFnolCategoryCreateResponses, PostAdminFnolCategoryRemoveConfirmationEmailTemplateData, PostAdminFnolCategoryRemoveConfirmationEmailTemplateErrors, PostAdminFnolCategoryRemoveConfirmationEmailTemplateResponses, PostAdminFnolCategoryRemoveData, PostAdminFnolCategoryRemoveErrors, PostAdminFnolCategoryRemoveResponses, PostAdminFnolCategoryRenameData, PostAdminFnolCategoryRenameErrors, PostAdminFnolCategoryRenameResponses, PostAdminFnolCategorySetConfirmationEmailTemplateData, PostAdminFnolCategorySetConfirmationEmailTemplateErrors, PostAdminFnolCategorySetConfirmationEmailTemplateResponses, PostAdminFnolCompleteWithPolicyData, PostAdminFnolCompleteWithPolicyErrors, PostAdminFnolCompleteWithPolicyResponses, PostAdminFnolCreateTemplateData, PostAdminFnolCreateTemplateErrors, PostAdminFnolCreateTemplateResponses, PostAdminFnolImportTemplatesData, PostAdminFnolImportTemplatesErrors, PostAdminFnolImportTemplatesResponses, PostAdminFnolRejectFnolData, PostAdminFnolRejectFnolErrors, PostAdminFnolRejectFnolResponses, PostAdminFnolSetIncidentDayData, PostAdminFnolSetIncidentDayErrors, PostAdminFnolSetIncidentDayResponses, PostAdminFnolSetInsuranceHolderData, PostAdminFnolSetInsuranceHolderErrors, PostAdminFnolSetInsuranceHolderResponses, PostAdminFnolSetInsuredObjectData, PostAdminFnolSetInsuredObjectErrors, PostAdminFnolSetInsuredObjectResponses, PostAdminFnolTemplateActivateData, PostAdminFnolTemplateActivateErrors, PostAdminFnolTemplateActivateInternalOnlyData, PostAdminFnolTemplateActivateInternalOnlyErrors, PostAdminFnolTemplateActivateInternalOnlyResponses, PostAdminFnolTemplateActivateResponses, PostAdminFnolTemplateChangeCategoryData, PostAdminFnolTemplateChangeCategoryErrors, PostAdminFnolTemplateChangeCategoryResponses, PostAdminFnolTemplateChangeDescriptionData, PostAdminFnolTemplateChangeDescriptionErrors, PostAdminFnolTemplateChangeDescriptionResponses, PostAdminFnolTemplateChangeIntroductionData, PostAdminFnolTemplateChangeIntroductionErrors, PostAdminFnolTemplateChangeIntroductionResponses, PostAdminFnolTemplateChangeOutroData, PostAdminFnolTemplateChangeOutroErrors, PostAdminFnolTemplateChangeOutroResponses, PostAdminFnolTemplateCreateQuestionTreeData, PostAdminFnolTemplateCreateQuestionTreeErrors, PostAdminFnolTemplateCreateQuestionTreeResponses, PostAdminFnolTemplateDeactivateData, PostAdminFnolTemplateDeactivateErrors, PostAdminFnolTemplateDeactivateResponses, PostAdminFnolTemplateQuestionTreeBranchChangeOrderData, PostAdminFnolTemplateQuestionTreeBranchChangeOrderErrors, PostAdminFnolTemplateQuestionTreeBranchChangeOrderResponses, PostAdminFnolTemplateQuestionTreeBranchRemoveData, PostAdminFnolTemplateQuestionTreeBranchRemoveErrors, PostAdminFnolTemplateQuestionTreeBranchRemoveResponses, PostAdminFnolTemplateQuestionTreeChangeOrderData, PostAdminFnolTemplateQuestionTreeChangeOrderErrors, PostAdminFnolTemplateQuestionTreeChangeOrderResponses, PostAdminFnolTemplateQuestionTreeCreateBranchData, PostAdminFnolTemplateQuestionTreeCreateBranchErrors, PostAdminFnolTemplateQuestionTreeCreateBranchResponses, PostAdminFnolTemplateQuestionTreeMakeMandatoryData, PostAdminFnolTemplateQuestionTreeMakeMandatoryErrors, PostAdminFnolTemplateQuestionTreeMakeMandatoryResponses, PostAdminFnolTemplateQuestionTreeMakeOptionalData, PostAdminFnolTemplateQuestionTreeMakeOptionalErrors, PostAdminFnolTemplateQuestionTreeMakeOptionalResponses, PostAdminFnolTemplateQuestionTreeRemoveData, PostAdminFnolTemplateQuestionTreeRemoveErrors, PostAdminFnolTemplateQuestionTreeRemoveResponses, PostAdminFnolTemplateRemoveData, PostAdminFnolTemplateRemoveErrors, PostAdminFnolTemplateRemoveResponses, PostAdminFnolTemplateRenameData, PostAdminFnolTemplateRenameErrors, PostAdminFnolTemplateRenameResponses, PostAdminFnolTemplateSetAutoCreateEmailTemplateData, PostAdminFnolTemplateSetAutoCreateEmailTemplateErrors, PostAdminFnolTemplateSetAutoCreateEmailTemplateResponses, PostAdminFossUpdateMarketCodeData, PostAdminFossUpdateMarketCodeErrors, PostAdminFossUpdateMarketCodeResponses, PostAdminInvoiceRecipientAddData, PostAdminInvoiceRecipientAddErrors, PostAdminInvoiceRecipientAddResponses, PostAdminInvoiceRecipientDeleteAddressData, PostAdminInvoiceRecipientDeleteAddressErrors, PostAdminInvoiceRecipientDeleteAddressResponses, PostAdminInvoiceRecipientDeleteEmailData, PostAdminInvoiceRecipientDeleteEmailErrors, PostAdminInvoiceRecipientDeleteEmailResponses, PostAdminInvoiceRecipientRemoveData, PostAdminInvoiceRecipientRemoveErrors, PostAdminInvoiceRecipientRemoveResponses, PostAdminInvoiceRecipientSetAddressData, PostAdminInvoiceRecipientSetAddressErrors, PostAdminInvoiceRecipientSetAddressResponses, PostAdminInvoiceRecipientSetEmailData, PostAdminInvoiceRecipientSetEmailErrors, PostAdminInvoiceRecipientSetEmailResponses, PostAdminPartnerSettingsSetAdminUrlData, PostAdminPartnerSettingsSetAdminUrlErrors, PostAdminPartnerSettingsSetAdminUrlResponses, PostAdminPartnerSettingsSetLogoData, PostAdminPartnerSettingsSetLogoErrors, PostAdminPartnerSettingsSetLogoResponses, PostAdminQuestionChangeDescriptionData, PostAdminQuestionChangeDescriptionErrors, PostAdminQuestionChangeDescriptionResponses, PostAdminQuestionChangePlaceholderData, PostAdminQuestionChangePlaceholderErrors, PostAdminQuestionChangePlaceholderResponses, PostAdminQuestionChangeTextData, PostAdminQuestionChangeTextErrors, PostAdminQuestionChangeTextResponses, PostAdminQuestionCreateData, PostAdminQuestionCreateErrors, PostAdminQuestionCreateResponses, PostAdminQuestionRemoveData, PostAdminQuestionRemoveErrors, PostAdminQuestionRemoveResponses, PostAdminSuggestorsRegisterSuggestorData, PostAdminSuggestorsRegisterSuggestorErrors, PostAdminSuggestorsRegisterSuggestorResponses, PostAdminSuggestorsSetFeedbackUrlData, PostAdminSuggestorsSetFeedbackUrlErrors, PostAdminSuggestorsSetFeedbackUrlResponses, PostAdminSuggestorsUnregisterSuggestorData, PostAdminSuggestorsUnregisterSuggestorErrors, PostAdminSuggestorsUnregisterSuggestorResponses, PostAdminUserSettingsSetWorkTitleData, PostAdminUserSettingsSetWorkTitleErrors, PostAdminUserSettingsSetWorkTitleResponses, PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionData, PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionErrors, PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionResponses, PostClaimcaseByKeyByClaimcaseKeyAddFileData, PostClaimcaseByKeyByClaimcaseKeyAddFileErrors, PostClaimcaseByKeyByClaimcaseKeyAddFileResponses, PostClaimcaseByKeyByClaimcaseKeyAddStakeholderData, PostClaimcaseByKeyByClaimcaseKeyAddStakeholderErrors, PostClaimcaseByKeyByClaimcaseKeyAddStakeholderResponses, PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionData, PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionErrors, PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionResponses, PostClaimcaseByKeyByClaimcaseKeyAssignToData, PostClaimcaseByKeyByClaimcaseKeyAssignToErrors, PostClaimcaseByKeyByClaimcaseKeyAssignToMeData, PostClaimcaseByKeyByClaimcaseKeyAssignToMeErrors, PostClaimcaseByKeyByClaimcaseKeyAssignToMeResponses, PostClaimcaseByKeyByClaimcaseKeyAssignToResponses, PostClaimcaseByKeyByClaimcaseKeyChangePolicyData, PostClaimcaseByKeyByClaimcaseKeyChangePolicyErrors, PostClaimcaseByKeyByClaimcaseKeyChangePolicyResponses, PostClaimcaseByKeyByClaimcaseKeyChangeReportDayData, PostClaimcaseByKeyByClaimcaseKeyChangeReportDayErrors, PostClaimcaseByKeyByClaimcaseKeyChangeReportDayResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeData, PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeErrors, PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionData, PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionErrors, PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationData, PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationErrors, PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationResponses, PostClaimcaseByKeyByClaimcaseKeyClaimCreateData, PostClaimcaseByKeyByClaimcaseKeyClaimCreateErrors, PostClaimcaseByKeyByClaimcaseKeyClaimCreateResponses, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingData, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingErrors, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingResponses, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseData, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseErrors, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutData, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutErrors, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddData, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddErrors, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountData, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountErrors, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveData, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleData, PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleErrors, PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRemoveData, PostClaimcaseByKeyByClaimcaseKeyClaimRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyClaimRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimReopenData, PostClaimcaseByKeyByClaimcaseKeyClaimReopenErrors, PostClaimcaseByKeyByClaimcaseKeyClaimReopenResponses, PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveData, PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveErrors, PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimSettleData, PostClaimcaseByKeyByClaimcaseKeyClaimSettleErrors, PostClaimcaseByKeyByClaimcaseKeyClaimSettleResponses, PostClaimcaseByKeyByClaimcaseKeyCloseData, PostClaimcaseByKeyByClaimcaseKeyCloseErrors, PostClaimcaseByKeyByClaimcaseKeyCloseResponses, PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddData, PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddErrors, PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddResponses, PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveData, PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteData, PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteErrors, PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteResponses, PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedData, PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedErrors, PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedResponses, PostClaimcaseByKeyByClaimcaseKeyEmailRemoveData, PostClaimcaseByKeyByClaimcaseKeyEmailRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyEmailRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSendData, PostClaimcaseByKeyByClaimcaseKeyEmailSendErrors, PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyData, PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyErrors, PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSendResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelData, PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelErrors, PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusData, PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusErrors, PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelData, PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelErrors, PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveData, PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyExternalRefSetData, PostClaimcaseByKeyByClaimcaseKeyExternalRefSetErrors, PostClaimcaseByKeyByClaimcaseKeyExternalRefSetResponses, PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentData, PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentErrors, PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimData, PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimErrors, PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimResponses, PostClaimcaseByKeyByClaimcaseKeyImportData, PostClaimcaseByKeyByClaimcaseKeyImportErrors, PostClaimcaseByKeyByClaimcaseKeyImportResponses, PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentData, PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentErrors, PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyMakeInternalData, PostClaimcaseByKeyByClaimcaseKeyMakeInternalErrors, PostClaimcaseByKeyByClaimcaseKeyMakeInternalResponses, PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingData, PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingErrors, PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingResponses, PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseData, PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseErrors, PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseResponses, PostClaimcaseByKeyByClaimcaseKeyNoteAddData, PostClaimcaseByKeyByClaimcaseKeyNoteAddErrors, PostClaimcaseByKeyByClaimcaseKeyNoteAddResponses, PostClaimcaseByKeyByClaimcaseKeyNoteRemoveData, PostClaimcaseByKeyByClaimcaseKeyNoteRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyNoteRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyNoteUpdateData, PostClaimcaseByKeyByClaimcaseKeyNoteUpdateErrors, PostClaimcaseByKeyByClaimcaseKeyNoteUpdateResponses, PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyData, PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyErrors, PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyResponses, PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionData, PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionErrors, PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionResponses, PostClaimcaseByKeyByClaimcaseKeyRemoveFileData, PostClaimcaseByKeyByClaimcaseKeyRemoveFileErrors, PostClaimcaseByKeyByClaimcaseKeyRemoveFileResponses, PostClaimcaseByKeyByClaimcaseKeyRenameFileData, PostClaimcaseByKeyByClaimcaseKeyRenameFileErrors, PostClaimcaseByKeyByClaimcaseKeyRenameFileResponses, PostClaimcaseByKeyByClaimcaseKeyReopenData, PostClaimcaseByKeyByClaimcaseKeyReopenErrors, PostClaimcaseByKeyByClaimcaseKeyReopenResponses, PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveData, PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetData, PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetErrors, PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetResponses, PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressData, PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressErrors, PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressResponses, PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelData, PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelErrors, PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeySetIncidentDayData, PostClaimcaseByKeyByClaimcaseKeySetIncidentDayErrors, PostClaimcaseByKeyByClaimcaseKeySetIncidentDayResponses, PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusData, PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusErrors, PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionData, PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerData, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveData, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerData, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailData, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberData, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberErrors, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberResponses, PostClaimcaseByKeyByClaimcaseKeyTaskAddData, PostClaimcaseByKeyByClaimcaseKeyTaskAddErrors, PostClaimcaseByKeyByClaimcaseKeyTaskAddResponses, PostClaimcaseByKeyByClaimcaseKeyTaskEditData, PostClaimcaseByKeyByClaimcaseKeyTaskEditErrors, PostClaimcaseByKeyByClaimcaseKeyTaskEditResponses, PostClaimcaseByKeyByClaimcaseKeyTaskRemoveData, PostClaimcaseByKeyByClaimcaseKeyTaskRemoveErrors, PostClaimcaseByKeyByClaimcaseKeyTaskRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineData, PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineErrors, PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineResponses, PostClaimcaseByKeyByClaimcaseKeyTaskSetStateData, PostClaimcaseByKeyByClaimcaseKeyTaskSetStateErrors, PostClaimcaseByKeyByClaimcaseKeyTaskSetStateResponses, PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentData, PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentErrors, PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeData, PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeErrors, PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeResponses, PostClaimcaseCreateData, PostClaimcaseCreateErrors, PostClaimcaseCreateFromFnolData, PostClaimcaseCreateFromFnolErrors, PostClaimcaseCreateFromFnolResponses, PostClaimcaseCreateResponses, PostClaimcaseImportCsvData, PostClaimcaseImportCsvErrors, PostClaimcaseImportCsvResponses, PostCognitoAdminAddUserData, PostCognitoAdminAddUserErrors, PostCognitoAdminAddUserResponses, PostCognitoAdminAssignOrUpdateRoleByUsernameData, PostCognitoAdminAssignOrUpdateRoleByUsernameErrors, PostCognitoAdminAssignOrUpdateRoleByUsernameResponses, PostCognitoAdminListUsersData, PostCognitoAdminListUsersResponses, PostCognitoAdminRemoveRoleByUsernameData, PostCognitoAdminRemoveRoleByUsernameErrors, PostCognitoAdminRemoveRoleByUsernameResponses, PostCognitoAdminRemoveUserByUsernameData, PostCognitoAdminRemoveUserByUsernameErrors, PostCognitoAdminRemoveUserByUsernameResponses, PostCognitoAdminResetPasswordByUsernameData, PostCognitoAdminResetPasswordByUsernameErrors, PostCognitoAdminResetPasswordByUsernameResponses, PostCognitoAdminUpdateUserByUsernameData, PostCognitoAdminUpdateUserByUsernameErrors, PostCognitoAdminUpdateUserByUsernameResponses, PostDebugData, PostDebugErrors, PostDebugResponses, PostEmailAddClaimcaseLabelData, PostEmailAddClaimcaseLabelErrors, PostEmailAddClaimcaseLabelResponses, PostEmailAddNoClaimcaseLabelData, PostEmailAddNoClaimcaseLabelErrors, PostEmailAddNoClaimcaseLabelResponses, PostEmailChangeClaimcaseLabelData, PostEmailChangeClaimcaseLabelErrors, PostEmailChangeClaimcaseLabelResponses, PostEmailCleanupOldClaimcasesData, PostEmailCleanupOldClaimcasesErrors, PostEmailCleanupOldClaimcasesResponses, PostEmailRemoveClaimcaseLabelData, PostEmailRemoveClaimcaseLabelErrors, PostEmailRemoveClaimcaseLabelResponses, PostEmailSyncClaimcaseData, PostEmailSyncClaimcaseErrors, PostEmailSyncClaimcaseResponses, PostEmailSyncFullData, PostEmailSyncFullResponses, PostEmailSyncUnlabeledData, PostEmailSyncUnlabeledResponses, PostFnolAddAttachmentData, PostFnolAddAttachmentErrors, PostFnolAddAttachmentResponses, PostFnolCompleteData, PostFnolCompleteErrors, PostFnolCompleteResponses, PostFnolInitData, PostFnolInitErrors, PostFnolInitResponses, PostFnolRemoveAttachmentData, PostFnolRemoveAttachmentErrors, PostFnolRemoveAttachmentResponses, PostFnolSetCustomEmailData, PostFnolSetCustomEmailErrors, PostFnolSetCustomEmailResponses, PostFnolSetCustomPhoneNumberData, PostFnolSetCustomPhoneNumberErrors, PostFnolSetCustomPhoneNumberResponses, PostFnolSetIncidentDayData, PostFnolSetIncidentDayErrors, PostFnolSetIncidentDayResponses, PostFnolSetInsuranceHolderData, PostFnolSetInsuranceHolderErrors, PostFnolSetInsuranceHolderResponses, PostFnolSetInsuredObjectData, PostFnolSetInsuredObjectErrors, PostFnolSetInsuredObjectResponses, PostFnolSetVarData, PostFnolSetVarErrors, PostFnolSetVarResponses, PostGmailDisconnectData, PostGmailDisconnectResponses, PostReportRecalculateKpisData, PostReportRecalculateKpisResponses, PostS3PresignGetPresignUrlData, PostS3PresignGetPresignUrlErrors, PostS3PresignGetPresignUrlResponses, PostSebIntegrationExportPain001PaymentsBeforeData, PostSebIntegrationExportPain001PaymentsBeforeErrors, PostSebIntegrationExportPain001PaymentsBeforeResponses, PostSebIntegrationExportPain001PaymentsData, PostSebIntegrationExportPain001PaymentsErrors, PostSebIntegrationExportPain001PaymentsResponses, PostSebIntegrationImportCamtTransactionData, PostSebIntegrationImportCamtTransactionErrors, PostSebIntegrationImportCamtTransactionResponses, PostSebIntegrationImportPain002ReportData, PostSebIntegrationImportPain002ReportErrors, PostSebIntegrationImportPain002ReportResponses, PostSendUnlabeledForwardData, PostSendUnlabeledForwardErrors, PostSendUnlabeledForwardResponses, PostSendUnlabeledReplyData, PostSendUnlabeledReplyErrors, PostSendUnlabeledReplyResponses, PostSkadehubPollData, PostSkadehubPollResponses, PostSkadehubSetIncidentStatusData, PostSkadehubSetIncidentStatusErrors, PostSkadehubSetIncidentStatusResponses, PostSuggestorsTestSuggestorClaimcaseSuggestionsData, PostSuggestorsTestSuggestorClaimcaseSuggestionsErrors, PostSuggestorsTestSuggestorClaimcaseSuggestionsResponses, PostSuggestorsTestSuggestorFeedbackData, PostSuggestorsTestSuggestorFeedbackErrors, PostSuggestorsTestSuggestorFeedbackResponses, PostSuggestorsTestSuggestorFnolSuggestionsData, PostSuggestorsTestSuggestorFnolSuggestionsErrors, PostSuggestorsTestSuggestorFnolSuggestionsResponses, PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsData, PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsErrors, PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postAdminAutoCreateEmailTemplateChangeBody = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateChangeBodyData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateChangeBodyResponses, PostAdminAutoCreateEmailTemplateChangeBodyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/ChangeBody',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminAutoCreateEmailTemplateChangeSubject = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateChangeSubjectData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateChangeSubjectResponses, PostAdminAutoCreateEmailTemplateChangeSubjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/ChangeSubject',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminAutoCreateEmailTemplateCreate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateCreateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateCreateResponses, PostAdminAutoCreateEmailTemplateCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminAutoCreateEmailTemplateDelete = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateDeleteData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateDeleteResponses, PostAdminAutoCreateEmailTemplateDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/Delete',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminAutoCreateEmailTemplateExportTemplates = <ThrowOnError extends boolean = true>(options?: Options<GetAdminAutoCreateEmailTemplateExportTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAutoCreateEmailTemplateExportTemplatesResponses, GetAdminAutoCreateEmailTemplateExportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/ExportTemplates',
    ...options
});

export const getAdminAutoCreateEmailTemplateGet = <ThrowOnError extends boolean = true>(options: Options<GetAdminAutoCreateEmailTemplateGetData, ThrowOnError>) => (options.client ?? client).get<GetAdminAutoCreateEmailTemplateGetResponses, GetAdminAutoCreateEmailTemplateGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/Get',
    ...options
});

export const postAdminAutoCreateEmailTemplateImportTemplates = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateImportTemplatesData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateImportTemplatesResponses, PostAdminAutoCreateEmailTemplateImportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/ImportTemplates',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminAutoCreateEmailTemplateList = <ThrowOnError extends boolean = true>(options?: Options<GetAdminAutoCreateEmailTemplateListData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAutoCreateEmailTemplateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/List',
    ...options
});

export const getAdminAutoCreateEmailTemplateListVariables = <ThrowOnError extends boolean = true>(options?: Options<GetAdminAutoCreateEmailTemplateListVariablesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAutoCreateEmailTemplateListVariablesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/ListVariables',
    ...options
});

export const postAdminAutoCreateEmailTemplateRename = <ThrowOnError extends boolean = true>(options?: Options<PostAdminAutoCreateEmailTemplateRenameData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAutoCreateEmailTemplateRenameResponses, PostAdminAutoCreateEmailTemplateRenameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplate/Rename',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminAutoCreateEmailTemplatePreviewPreview = <ThrowOnError extends boolean = true>(options: Options<GetAdminAutoCreateEmailTemplatePreviewPreviewData, ThrowOnError>) => (options.client ?? client).get<GetAdminAutoCreateEmailTemplatePreviewPreviewResponses, GetAdminAutoCreateEmailTemplatePreviewPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/AutoCreateEmailTemplatePreview/Preview',
    ...options
});

export const postAdminClaimtypeCopy = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeCopyData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeCopyResponses, PostAdminClaimtypeCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/Copy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeCreate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeCreateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeCreateResponses, PostAdminClaimtypeCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeDelete = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeDeleteData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeDeleteResponses, PostAdminClaimtypeDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/Delete',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminClaimtypeGet = <ThrowOnError extends boolean = true>(options?: Options<GetAdminClaimtypeGetData, ThrowOnError>) => (options?.client ?? client).get<GetAdminClaimtypeGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/Get',
    ...options
});

export const postAdminClaimtypeMove = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeMoveData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeMoveResponses, PostAdminClaimtypeMoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/Move',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateDefaultReserveAmount = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateDefaultReserveAmountData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateDefaultReserveAmountResponses, PostAdminClaimtypeUpdateDefaultReserveAmountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateDefaultReserveAmount',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateDescription = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateDescriptionData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateDescriptionResponses, PostAdminClaimtypeUpdateDescriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateDescription',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateFossType = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateFossTypeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateFossTypeResponses, PostAdminClaimtypeUpdateFossTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateFossType',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateGsrType = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateGsrTypeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateGsrTypeResponses, PostAdminClaimtypeUpdateGsrTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateGsrType',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateInitialRecoveryExpectation = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateInitialRecoveryExpectationData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateInitialRecoveryExpectationResponses, PostAdminClaimtypeUpdateInitialRecoveryExpectationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateInitialRecoveryExpectation',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminClaimtypeUpdateName = <ThrowOnError extends boolean = true>(options?: Options<PostAdminClaimtypeUpdateNameData, ThrowOnError>) => (options?.client ?? client).post<PostAdminClaimtypeUpdateNameResponses, PostAdminClaimtypeUpdateNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Claimtype/UpdateName',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailSignatureChange = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailSignatureChangeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailSignatureChangeResponses, PostAdminEmailSignatureChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailSignature/Change',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminEmailSignatureGet = <ThrowOnError extends boolean = true>(options?: Options<GetAdminEmailSignatureGetData, ThrowOnError>) => (options?.client ?? client).get<GetAdminEmailSignatureGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailSignature/Get',
    ...options
});

export const postAdminEmailTemplateChangeBody = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateChangeBodyData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateChangeBodyResponses, PostAdminEmailTemplateChangeBodyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/ChangeBody',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateChangeSubject = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateChangeSubjectData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateChangeSubjectResponses, PostAdminEmailTemplateChangeSubjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/ChangeSubject',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateCreate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateCreateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateCreateResponses, PostAdminEmailTemplateCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateCreateVariable = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateCreateVariableData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateCreateVariableResponses, PostAdminEmailTemplateCreateVariableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/CreateVariable',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateDelete = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateDeleteData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateDeleteResponses, PostAdminEmailTemplateDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/Delete',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateDeleteVariable = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateDeleteVariableData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateDeleteVariableResponses, PostAdminEmailTemplateDeleteVariableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/DeleteVariable',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminEmailTemplateExportTemplates = <ThrowOnError extends boolean = true>(options?: Options<GetAdminEmailTemplateExportTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminEmailTemplateExportTemplatesResponses, GetAdminEmailTemplateExportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/ExportTemplates',
    ...options
});

export const getAdminEmailTemplateGet = <ThrowOnError extends boolean = true>(options: Options<GetAdminEmailTemplateGetData, ThrowOnError>) => (options.client ?? client).get<GetAdminEmailTemplateGetResponses, GetAdminEmailTemplateGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/Get',
    ...options
});

export const postAdminEmailTemplateImportTemplates = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateImportTemplatesData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateImportTemplatesResponses, PostAdminEmailTemplateImportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/ImportTemplates',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminEmailTemplateList = <ThrowOnError extends boolean = true>(options?: Options<GetAdminEmailTemplateListData, ThrowOnError>) => (options?.client ?? client).get<GetAdminEmailTemplateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/List',
    ...options
});

export const getAdminEmailTemplateListVariables = <ThrowOnError extends boolean = true>(options?: Options<GetAdminEmailTemplateListVariablesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminEmailTemplateListVariablesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/ListVariables',
    ...options
});

export const postAdminEmailTemplateRename = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateRenameData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateRenameResponses, PostAdminEmailTemplateRenameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/Rename',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminEmailTemplateUpdateVariable = <ThrowOnError extends boolean = true>(options?: Options<PostAdminEmailTemplateUpdateVariableData, ThrowOnError>) => (options?.client ?? client).post<PostAdminEmailTemplateUpdateVariableResponses, PostAdminEmailTemplateUpdateVariableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/EmailTemplate/UpdateVariable',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminFossListIncidentTypes = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFossListIncidentTypesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFossListIncidentTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Foss/ListIncidentTypes',
    ...options
});

export const getAdminFossListMarketCodes = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFossListMarketCodesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFossListMarketCodesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Foss/ListMarketCodes',
    ...options
});

export const postAdminFossUpdateMarketCode = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFossUpdateMarketCodeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFossUpdateMarketCodeResponses, PostAdminFossUpdateMarketCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Foss/UpdateMarketCode',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminGsrListInsuranceCompanies = <ThrowOnError extends boolean = true>(options?: Options<GetAdminGsrListInsuranceCompaniesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminGsrListInsuranceCompaniesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Gsr/ListInsuranceCompanies',
    ...options
});

export const getAdminGsrListTypes = <ThrowOnError extends boolean = true>(options?: Options<GetAdminGsrListTypesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminGsrListTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Gsr/ListTypes',
    ...options
});

export const postAdminInvoiceRecipientAdd = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientAddData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientAddResponses, PostAdminInvoiceRecipientAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/Add',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminInvoiceRecipientDeleteAddress = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientDeleteAddressData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientDeleteAddressResponses, PostAdminInvoiceRecipientDeleteAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/DeleteAddress',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminInvoiceRecipientDeleteEmail = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientDeleteEmailData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientDeleteEmailResponses, PostAdminInvoiceRecipientDeleteEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/DeleteEmail',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminInvoiceRecipientRemove = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientRemoveData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientRemoveResponses, PostAdminInvoiceRecipientRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminInvoiceRecipientSetAddress = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientSetAddressData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientSetAddressResponses, PostAdminInvoiceRecipientSetAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/SetAddress',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminInvoiceRecipientSetEmail = <ThrowOnError extends boolean = true>(options?: Options<PostAdminInvoiceRecipientSetEmailData, ThrowOnError>) => (options?.client ?? client).post<PostAdminInvoiceRecipientSetEmailResponses, PostAdminInvoiceRecipientSetEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/InvoiceRecipient/SetEmail',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminPartnerSettingsGetCurrent = <ThrowOnError extends boolean = true>(options?: Options<GetAdminPartnerSettingsGetCurrentData, ThrowOnError>) => (options?.client ?? client).get<GetAdminPartnerSettingsGetCurrentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/PartnerSettings/GetCurrent',
    ...options
});

export const postAdminPartnerSettingsSetAdminUrl = <ThrowOnError extends boolean = true>(options?: Options<PostAdminPartnerSettingsSetAdminUrlData, ThrowOnError>) => (options?.client ?? client).post<PostAdminPartnerSettingsSetAdminUrlResponses, PostAdminPartnerSettingsSetAdminUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/PartnerSettings/SetAdminUrl',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminPartnerSettingsSetLogo = <ThrowOnError extends boolean = true>(options?: Options<PostAdminPartnerSettingsSetLogoData, ThrowOnError>) => (options?.client ?? client).post<PostAdminPartnerSettingsSetLogoResponses, PostAdminPartnerSettingsSetLogoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/PartnerSettings/SetLogo',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminQuestionChangeDescription = <ThrowOnError extends boolean = true>(options?: Options<PostAdminQuestionChangeDescriptionData, ThrowOnError>) => (options?.client ?? client).post<PostAdminQuestionChangeDescriptionResponses, PostAdminQuestionChangeDescriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Question/ChangeDescription',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminQuestionChangePlaceholder = <ThrowOnError extends boolean = true>(options?: Options<PostAdminQuestionChangePlaceholderData, ThrowOnError>) => (options?.client ?? client).post<PostAdminQuestionChangePlaceholderResponses, PostAdminQuestionChangePlaceholderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Question/ChangePlaceholder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminQuestionChangeText = <ThrowOnError extends boolean = true>(options?: Options<PostAdminQuestionChangeTextData, ThrowOnError>) => (options?.client ?? client).post<PostAdminQuestionChangeTextResponses, PostAdminQuestionChangeTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Question/ChangeText',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminQuestionCreate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminQuestionCreateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminQuestionCreateResponses, PostAdminQuestionCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Question/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminQuestionRemove = <ThrowOnError extends boolean = true>(options?: Options<PostAdminQuestionRemoveData, ThrowOnError>) => (options?.client ?? client).post<PostAdminQuestionRemoveResponses, PostAdminQuestionRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Question/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminSuggestorsGetAllSuggestors = <ThrowOnError extends boolean = true>(options?: Options<GetAdminSuggestorsGetAllSuggestorsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminSuggestorsGetAllSuggestorsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Suggestors/GetAllSuggestors',
    ...options
});

export const getAdminSuggestorsGetSuggestorErrors = <ThrowOnError extends boolean = true>(options: Options<GetAdminSuggestorsGetSuggestorErrorsData, ThrowOnError>) => (options.client ?? client).get<GetAdminSuggestorsGetSuggestorErrorsResponses, GetAdminSuggestorsGetSuggestorErrorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Suggestors/GetSuggestorErrors',
    ...options
});

export const postAdminSuggestorsRegisterSuggestor = <ThrowOnError extends boolean = true>(options?: Options<PostAdminSuggestorsRegisterSuggestorData, ThrowOnError>) => (options?.client ?? client).post<PostAdminSuggestorsRegisterSuggestorResponses, PostAdminSuggestorsRegisterSuggestorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Suggestors/RegisterSuggestor',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminSuggestorsSetFeedbackUrl = <ThrowOnError extends boolean = true>(options: Options<PostAdminSuggestorsSetFeedbackUrlData, ThrowOnError>) => (options.client ?? client).post<PostAdminSuggestorsSetFeedbackUrlResponses, PostAdminSuggestorsSetFeedbackUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Suggestors/SetFeedbackUrl',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminSuggestorsUnregisterSuggestor = <ThrowOnError extends boolean = true>(options: Options<PostAdminSuggestorsUnregisterSuggestorData, ThrowOnError>) => (options.client ?? client).post<PostAdminSuggestorsUnregisterSuggestorResponses, PostAdminSuggestorsUnregisterSuggestorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/Suggestors/UnregisterSuggestor',
    ...options
});

export const getAdminUserSettingsGetCurrent = <ThrowOnError extends boolean = true>(options?: Options<GetAdminUserSettingsGetCurrentData, ThrowOnError>) => (options?.client ?? client).get<GetAdminUserSettingsGetCurrentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/UserSettings/GetCurrent',
    ...options
});

export const postAdminUserSettingsSetWorkTitle = <ThrowOnError extends boolean = true>(options?: Options<PostAdminUserSettingsSetWorkTitleData, ThrowOnError>) => (options?.client ?? client).post<PostAdminUserSettingsSetWorkTitleResponses, PostAdminUserSettingsSetWorkTitleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Admin/UserSettings/SetWorkTitle',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryChangeIncidentDayQuery = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryChangeIncidentDayQueryData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryChangeIncidentDayQueryResponses, PostAdminFnolCategoryChangeIncidentDayQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/ChangeIncidentDayQuery',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryChangeInsuranceHolderType = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryChangeInsuranceHolderTypeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryChangeInsuranceHolderTypeResponses, PostAdminFnolCategoryChangeInsuranceHolderTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/ChangeInsuranceHolderType',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryChangeInsuredObjectType = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryChangeInsuredObjectTypeData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryChangeInsuredObjectTypeResponses, PostAdminFnolCategoryChangeInsuredObjectTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/ChangeInsuredObjectType',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryCreate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryCreateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryCreateResponses, PostAdminFnolCategoryCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminFnolCategoryGetConfirmationEmailTemplate = <ThrowOnError extends boolean = true>(options: Options<GetAdminFnolCategoryGetConfirmationEmailTemplateData, ThrowOnError>) => (options.client ?? client).get<GetAdminFnolCategoryGetConfirmationEmailTemplateResponses, GetAdminFnolCategoryGetConfirmationEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/GetConfirmationEmailTemplate',
    ...options
});

export const getAdminFnolCategoryList = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolCategoryListData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolCategoryListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/List',
    ...options
});

export const postAdminFnolCategoryRemove = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryRemoveData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryRemoveResponses, PostAdminFnolCategoryRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryRemoveConfirmationEmailTemplate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryRemoveConfirmationEmailTemplateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryRemoveConfirmationEmailTemplateResponses, PostAdminFnolCategoryRemoveConfirmationEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/RemoveConfirmationEmailTemplate',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategoryRename = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategoryRenameData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategoryRenameResponses, PostAdminFnolCategoryRenameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/Rename',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCategorySetConfirmationEmailTemplate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCategorySetConfirmationEmailTemplateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCategorySetConfirmationEmailTemplateResponses, PostAdminFnolCategorySetConfirmationEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/SetConfirmationEmailTemplate',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminFnolCategoryTemplateListVariables = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolCategoryTemplateListVariablesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolCategoryTemplateListVariablesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Category/TemplateListVariables',
    ...options
});

export const postAdminFnolCompleteWithPolicy = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCompleteWithPolicyData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCompleteWithPolicyResponses, PostAdminFnolCompleteWithPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/CompleteWithPolicy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolCreateTemplate = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolCreateTemplateData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolCreateTemplateResponses, PostAdminFnolCreateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/CreateTemplate',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getAdminFnolExportAllTemplates = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolExportAllTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolExportAllTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/ExportAllTemplates',
    ...options
});

export const getAdminFnolExportTemplates = <ThrowOnError extends boolean = true>(options: Options<GetAdminFnolExportTemplatesData, ThrowOnError>) => (options.client ?? client).get<GetAdminFnolExportTemplatesResponses, GetAdminFnolExportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/ExportTemplates',
    ...options
});

export const getAdminFnolGet = <ThrowOnError extends boolean = true>(options: Options<GetAdminFnolGetData, ThrowOnError>) => (options.client ?? client).get<GetAdminFnolGetResponses, GetAdminFnolGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Get',
    ...options
});

export const getAdminFnolGetAllQuestions = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolGetAllQuestionsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolGetAllQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/GetAllQuestions',
    ...options
});

export const getAdminFnolGetCompleted = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolGetCompletedData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolGetCompletedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/GetCompleted',
    ...options
});

export const getAdminFnolGetOngoing = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolGetOngoingData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolGetOngoingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/GetOngoing',
    ...options
});

export const getAdminFnolGetRejected = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolGetRejectedData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolGetRejectedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/GetRejected',
    ...options
});

export const getAdminFnolGetTemplateSummaries = <ThrowOnError extends boolean = true>(options?: Options<GetAdminFnolGetTemplateSummariesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminFnolGetTemplateSummariesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/GetTemplateSummaries',
    ...options
});

export const postAdminFnolImportTemplates = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolImportTemplatesData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolImportTemplatesResponses, PostAdminFnolImportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/ImportTemplates',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolRejectFnol = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolRejectFnolData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolRejectFnolResponses, PostAdminFnolRejectFnolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/RejectFnol',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolSetIncidentDay = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolSetIncidentDayData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolSetIncidentDayResponses, PostAdminFnolSetIncidentDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/SetIncidentDay',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolSetInsuranceHolder = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolSetInsuranceHolderData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolSetInsuranceHolderResponses, PostAdminFnolSetInsuranceHolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/SetInsuranceHolder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolSetInsuredObject = <ThrowOnError extends boolean = true>(options?: Options<PostAdminFnolSetInsuredObjectData, ThrowOnError>) => (options?.client ?? client).post<PostAdminFnolSetInsuredObjectResponses, PostAdminFnolSetInsuredObjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/SetInsuredObject',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postAdminFnolTemplateActivate = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateActivateData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateActivateResponses, PostAdminFnolTemplateActivateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/Activate',
    ...options
});

export const postAdminFnolTemplateActivateInternalOnly = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateActivateInternalOnlyData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateActivateInternalOnlyResponses, PostAdminFnolTemplateActivateInternalOnlyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/ActivateInternalOnly',
    ...options
});

export const postAdminFnolTemplateChangeCategory = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateChangeCategoryData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateChangeCategoryResponses, PostAdminFnolTemplateChangeCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/ChangeCategory',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateChangeDescription = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateChangeDescriptionData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateChangeDescriptionResponses, PostAdminFnolTemplateChangeDescriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/ChangeDescription',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateChangeIntroduction = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateChangeIntroductionData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateChangeIntroductionResponses, PostAdminFnolTemplateChangeIntroductionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/ChangeIntroduction',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateChangeOutro = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateChangeOutroData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateChangeOutroResponses, PostAdminFnolTemplateChangeOutroErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/ChangeOutro',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateCreateQuestionTree = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateCreateQuestionTreeData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateCreateQuestionTreeResponses, PostAdminFnolTemplateCreateQuestionTreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/CreateQuestionTree',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateDeactivate = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateDeactivateData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateDeactivateResponses, PostAdminFnolTemplateDeactivateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/Deactivate',
    ...options
});

export const getAdminFnolTemplateGet = <ThrowOnError extends boolean = true>(options: Options<GetAdminFnolTemplateGetData, ThrowOnError>) => (options.client ?? client).get<GetAdminFnolTemplateGetResponses, GetAdminFnolTemplateGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/Get',
    ...options
});

export const postAdminFnolTemplateQuestionTreeBranchChangeOrder = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeBranchChangeOrderData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeBranchChangeOrderResponses, PostAdminFnolTemplateQuestionTreeBranchChangeOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/Branch/ChangeOrder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeBranchRemove = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeBranchRemoveData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeBranchRemoveResponses, PostAdminFnolTemplateQuestionTreeBranchRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/Branch/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeChangeOrder = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeChangeOrderData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeChangeOrderResponses, PostAdminFnolTemplateQuestionTreeChangeOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/ChangeOrder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeCreateBranch = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeCreateBranchData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeCreateBranchResponses, PostAdminFnolTemplateQuestionTreeCreateBranchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/CreateBranch',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeMakeMandatory = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeMakeMandatoryData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeMakeMandatoryResponses, PostAdminFnolTemplateQuestionTreeMakeMandatoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/MakeMandatory',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeMakeOptional = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeMakeOptionalData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeMakeOptionalResponses, PostAdminFnolTemplateQuestionTreeMakeOptionalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/MakeOptional',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateQuestionTreeRemove = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateQuestionTreeRemoveData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateQuestionTreeRemoveResponses, PostAdminFnolTemplateQuestionTreeRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/QuestionTree/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateRemove = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateRemoveData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateRemoveResponses, PostAdminFnolTemplateRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/Remove',
    ...options
});

export const postAdminFnolTemplateRename = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateRenameData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateRenameResponses, PostAdminFnolTemplateRenameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/Rename',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postAdminFnolTemplateSetAutoCreateEmailTemplate = <ThrowOnError extends boolean = true>(options: Options<PostAdminFnolTemplateSetAutoCreateEmailTemplateData, ThrowOnError>) => (options.client ?? client).post<PostAdminFnolTemplateSetAutoCreateEmailTemplateResponses, PostAdminFnolTemplateSetAutoCreateEmailTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/AdminFnol/Template/SetAutoCreateEmailTemplate',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAcceptSuggestion = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionResponses, PostClaimcaseByKeyByClaimcaseKeyAcceptSuggestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AcceptSuggestion',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAddFile = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAddFileData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAddFileResponses, PostClaimcaseByKeyByClaimcaseKeyAddFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AddFile',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAddStakeholder = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAddStakeholderData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAddStakeholderResponses, PostClaimcaseByKeyByClaimcaseKeyAddStakeholderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AddStakeholder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestion = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionResponses, PostClaimcaseByKeyByClaimcaseKeyAnswerCoverQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AnswerCoverQuestion',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAssignTo = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAssignToData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAssignToResponses, PostClaimcaseByKeyByClaimcaseKeyAssignToErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AssignTo',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyAssignToMe = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyAssignToMeData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyAssignToMeResponses, PostClaimcaseByKeyByClaimcaseKeyAssignToMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/AssignToMe',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyChangePolicy = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyChangePolicyData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyChangePolicyResponses, PostClaimcaseByKeyByClaimcaseKeyChangePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ChangePolicy',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyChangeReportDay = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyChangeReportDayData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyChangeReportDayResponses, PostClaimcaseByKeyByClaimcaseKeyChangeReportDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ChangeReportDay',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimChangeClaimType = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeClaimTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/ChangeClaimType',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimChangeDescription = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeDescriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/ChangeDescription',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectation = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationResponses, PostClaimcaseByKeyByClaimcaseKeyClaimChangeRecoveryExpectationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/ChangeRecoveryExpectation',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimCreate = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimCreateData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimCreateResponses, PostClaimcaseByKeyByClaimcaseKeyClaimCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoing = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingResponses, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsOngoingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/MarkAsOngoing',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToClose = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseResponses, PostClaimcaseByKeyByClaimcaseKeyClaimMarkAsReadyToCloseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/MarkAsReadyToClose',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPayment = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentAdjustFailedPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/AdjustFailedPayment',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHold = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentClearSanctionsHoldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/ClearSanctionsHold',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatch = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentConfirmSanctionsMatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/ConfirmSanctionsMatch',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilled = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentMarkAsFulfilledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/MarkAsFulfilled',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayout = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSchedulePayoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/SchedulePayout',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayout = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutResponses, PostClaimcaseByKeyByClaimcaseKeyClaimPaymentSignPayoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Payment/SignPayout',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimRecoveryAdd = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Recovery/Add',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmount = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryChangeAmountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Recovery/ChangeAmount',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoveryRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Recovery/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimRecoverySettle = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRecoverySettleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Recovery/Settle',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimReopen = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimReopenData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimReopenResponses, PostClaimcaseByKeyByClaimcaseKeyClaimReopenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimSetReserve = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveResponses, PostClaimcaseByKeyByClaimcaseKeyClaimSetReserveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/SetReserve',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClaimSettle = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyClaimSettleData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyClaimSettleResponses, PostClaimcaseByKeyByClaimcaseKeyClaimSettleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Claim/Settle',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyClose = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyCloseData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyCloseResponses, PostClaimcaseByKeyByClaimcaseKeyCloseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Close',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyCounterpartyAdd = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddResponses, PostClaimcaseByKeyByClaimcaseKeyCounterpartyAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Counterparty/Add',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyCounterpartyRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyCounterpartyRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Counterparty/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailChangeNote = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteResponses, PostClaimcaseByKeyByClaimcaseKeyEmailChangeNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/ChangeNote',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const getClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmpty = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateEmptyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/InstantiateEmpty',
    ...options
});

export const getClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplate = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/InstantiateTemplate',
    ...options
});

export const getClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBody = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyResponses, GetClaimcaseByKeyByClaimcaseKeyEmailInstantiateTemplateBodyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/InstantiateTemplateBody',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessed = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedResponses, PostClaimcaseByKeyByClaimcaseKeyEmailMoveToProcessedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/MoveToProcessed',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyEmailRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const getClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplate = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateResponses, GetClaimcaseByKeyByClaimcaseKeyEmailReplyQuotedTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/ReplyQuotedTemplate',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyEmailSend = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailSendData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailSendResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/Send',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailSendReply = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSendReplyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/SendReply',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevel = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetAttachmentSensitivityLevelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/SetAttachmentSensitivityLevel',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatus = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetHandledStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/SetHandledStatus',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevel = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeyEmailSetSensitivityLevelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Email/SetSensitivityLevel',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyExternalRefRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyExternalRefRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ExternalRef/Remove',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyExternalRefSet = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyExternalRefSetData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyExternalRefSetResponses, PostClaimcaseByKeyByClaimcaseKeyExternalRefSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ExternalRef/Set',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyFossSyncIncident = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyFossSyncIncidentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Foss/SyncIncident',
    ...options
});

export const getClaimcaseByKeyByClaimcaseKeyGet = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyGetData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyGetResponses, GetClaimcaseByKeyByClaimcaseKeyGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Get',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyGsrReportClaim = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimResponses, PostClaimcaseByKeyByClaimcaseKeyGsrReportClaimErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Gsr/ReportClaim',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyImport = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyImportData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyImportResponses, PostClaimcaseByKeyByClaimcaseKeyImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Import',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncident = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyLinkSkadehubIncidentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/LinkSkadehubIncident',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyMakeInternal = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyMakeInternalData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyMakeInternalResponses, PostClaimcaseByKeyByClaimcaseKeyMakeInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/MakeInternal',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyMarkAsOngoing = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingResponses, PostClaimcaseByKeyByClaimcaseKeyMarkAsOngoingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/MarkAsOngoing',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyMarkAsReadyToClose = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseResponses, PostClaimcaseByKeyByClaimcaseKeyMarkAsReadyToCloseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/MarkAsReadyToClose',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyNoteAdd = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyNoteAddData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyNoteAddResponses, PostClaimcaseByKeyByClaimcaseKeyNoteAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Note/Add',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyNoteRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyNoteRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyNoteRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyNoteRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Note/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyNoteUpdate = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyNoteUpdateData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyNoteUpdateResponses, PostClaimcaseByKeyByClaimcaseKeyNoteUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Note/Update',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const getClaimcaseByKeyByClaimcaseKeyPolicySwitchOptions = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsResponses, GetClaimcaseByKeyByClaimcaseKeyPolicySwitchOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/PolicySwitchOptions',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyRefreshPolicy = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyResponses, PostClaimcaseByKeyByClaimcaseKeyRefreshPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/RefreshPolicy',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyRejectSuggestion = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionResponses, PostClaimcaseByKeyByClaimcaseKeyRejectSuggestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/RejectSuggestion',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyRemoveFile = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyRemoveFileData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyRemoveFileResponses, PostClaimcaseByKeyByClaimcaseKeyRemoveFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/RemoveFile',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyRenameFile = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyRenameFileData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyRenameFileResponses, PostClaimcaseByKeyByClaimcaseKeyRenameFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/RenameFile',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyReopen = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyReopenData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyReopenResponses, PostClaimcaseByKeyByClaimcaseKeyReopenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Reopen',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyReviewFlagRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyReviewFlagRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ReviewFlag/Remove',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyReviewFlagSet = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetResponses, PostClaimcaseByKeyByClaimcaseKeyReviewFlagSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ReviewFlag/Set',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeySetEmailFromAddress = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressResponses, PostClaimcaseByKeyByClaimcaseKeySetEmailFromAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/SetEmailFromAddress',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevel = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelResponses, PostClaimcaseByKeyByClaimcaseKeySetFileSensitivityLevelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/SetFileSensitivityLevel',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeySetIncidentDay = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeySetIncidentDayData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeySetIncidentDayResponses, PostClaimcaseByKeyByClaimcaseKeySetIncidentDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/SetIncidentDay',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatus = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusResponses, PostClaimcaseByKeyByClaimcaseKeySetSkadehubMessageStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/SetSkadehubMessageStatus',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescription = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderChangeDescriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/ChangeDescription',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/Remove',
    ...options
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswer = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderRemoveAnswerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/RemoveAnswer',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswer = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetAnswerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/SetAnswer',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderSetEmail = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/SetEmail',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumber = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberResponses, PostClaimcaseByKeyByClaimcaseKeyStakeholderSetPhoneNumberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Stakeholder/SetPhoneNumber',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyTaskAdd = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyTaskAddData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyTaskAddResponses, PostClaimcaseByKeyByClaimcaseKeyTaskAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Task/Add',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyTaskEdit = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyTaskEditData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyTaskEditResponses, PostClaimcaseByKeyByClaimcaseKeyTaskEditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Task/Edit',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyTaskRemove = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyTaskRemoveData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyTaskRemoveResponses, PostClaimcaseByKeyByClaimcaseKeyTaskRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Task/Remove',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyTaskSetDeadline = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineResponses, PostClaimcaseByKeyByClaimcaseKeyTaskSetDeadlineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Task/SetDeadline',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyTaskSetState = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyTaskSetStateData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyTaskSetStateResponses, PostClaimcaseByKeyByClaimcaseKeyTaskSetStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/Task/SetState',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncident = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentResponses, PostClaimcaseByKeyByClaimcaseKeyUnlinkSkadehubIncidentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/UnlinkSkadehubIncident',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseByKeyByClaimcaseKeyValidatePolicyChange = <ThrowOnError extends boolean = true>(options: Options<PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeData, ThrowOnError>) => (options.client ?? client).post<PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeResponses, PostClaimcaseByKeyByClaimcaseKeyValidatePolicyChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ByKey/{claimcaseKey}/ValidatePolicyChange',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postClaimcaseCreate = <ThrowOnError extends boolean = true>(options?: Options<PostClaimcaseCreateData, ThrowOnError>) => (options?.client ?? client).post<PostClaimcaseCreateResponses, PostClaimcaseCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/Create',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postClaimcaseCreateFromFnol = <ThrowOnError extends boolean = true>(options?: Options<PostClaimcaseCreateFromFnolData, ThrowOnError>) => (options?.client ?? client).post<PostClaimcaseCreateFromFnolResponses, PostClaimcaseCreateFromFnolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/CreateFromFnol',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getClaimcaseGetClosed = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseGetClosedData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseGetClosedResponses, GetClaimcaseGetClosedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/GetClosed',
    ...options
});

export const getClaimcaseGetExternal = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseGetExternalData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseGetExternalResponses, GetClaimcaseGetExternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/GetExternal',
    ...options
});

export const getClaimcaseGetOpen = <ThrowOnError extends boolean = true>(options: Options<GetClaimcaseGetOpenData, ThrowOnError>) => (options.client ?? client).get<GetClaimcaseGetOpenResponses, GetClaimcaseGetOpenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/GetOpen',
    ...options
});

export const postClaimcaseImportCsv = <ThrowOnError extends boolean = true>(options?: Options<PostClaimcaseImportCsvData, ThrowOnError>) => (options?.client ?? client).post<PostClaimcaseImportCsvResponses, PostClaimcaseImportCsvErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ImportCSV',
    ...options,
    headers: {
        'Content-Type': 'text/csv;charset=utf-8',
        ...options?.headers
    }
});

export const getClaimcaseListRefs = <ThrowOnError extends boolean = true>(options?: Options<GetClaimcaseListRefsData, ThrowOnError>) => (options?.client ?? client).get<GetClaimcaseListRefsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Claimcase/ListRefs',
    ...options
});

export const postCognitoAdminAddUser = <ThrowOnError extends boolean = true>(options?: Options<PostCognitoAdminAddUserData, ThrowOnError>) => (options?.client ?? client).post<PostCognitoAdminAddUserResponses, PostCognitoAdminAddUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/AddUser',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postCognitoAdminAssignOrUpdateRoleByUsername = <ThrowOnError extends boolean = true>(options: Options<PostCognitoAdminAssignOrUpdateRoleByUsernameData, ThrowOnError>) => (options.client ?? client).post<PostCognitoAdminAssignOrUpdateRoleByUsernameResponses, PostCognitoAdminAssignOrUpdateRoleByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/AssignOrUpdateRole/{username}',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const getCognitoAdminGetUserByUsername = <ThrowOnError extends boolean = true>(options: Options<GetCognitoAdminGetUserByUsernameData, ThrowOnError>) => (options.client ?? client).get<GetCognitoAdminGetUserByUsernameResponses, GetCognitoAdminGetUserByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/GetUser/{username}',
    ...options
});

export const getCognitoAdminListClaimsHandlers = <ThrowOnError extends boolean = true>(options?: Options<GetCognitoAdminListClaimsHandlersData, ThrowOnError>) => (options?.client ?? client).get<GetCognitoAdminListClaimsHandlersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/ListClaimsHandlers',
    ...options
});

export const postCognitoAdminListUsers = <ThrowOnError extends boolean = true>(options?: Options<PostCognitoAdminListUsersData, ThrowOnError>) => (options?.client ?? client).post<PostCognitoAdminListUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/ListUsers',
    ...options
});

export const postCognitoAdminRemoveRoleByUsername = <ThrowOnError extends boolean = true>(options: Options<PostCognitoAdminRemoveRoleByUsernameData, ThrowOnError>) => (options.client ?? client).post<PostCognitoAdminRemoveRoleByUsernameResponses, PostCognitoAdminRemoveRoleByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/RemoveRole/{username}',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postCognitoAdminRemoveUserByUsername = <ThrowOnError extends boolean = true>(options: Options<PostCognitoAdminRemoveUserByUsernameData, ThrowOnError>) => (options.client ?? client).post<PostCognitoAdminRemoveUserByUsernameResponses, PostCognitoAdminRemoveUserByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/RemoveUser/{username}',
    ...options
});

export const postCognitoAdminResetPasswordByUsername = <ThrowOnError extends boolean = true>(options: Options<PostCognitoAdminResetPasswordByUsernameData, ThrowOnError>) => (options.client ?? client).post<PostCognitoAdminResetPasswordByUsernameResponses, PostCognitoAdminResetPasswordByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/ResetPassword/{username}',
    ...options
});

export const postCognitoAdminUpdateUserByUsername = <ThrowOnError extends boolean = true>(options: Options<PostCognitoAdminUpdateUserByUsernameData, ThrowOnError>) => (options.client ?? client).post<PostCognitoAdminUpdateUserByUsernameResponses, PostCognitoAdminUpdateUserByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Cognito/Admin/UpdateUser/{username}',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postDebug = <ThrowOnError extends boolean = true>(options?: Options<PostDebugData, ThrowOnError>) => (options?.client ?? client).post<PostDebugResponses, PostDebugErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Debug',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postEmailAddClaimcaseLabel = <ThrowOnError extends boolean = true>(options: Options<PostEmailAddClaimcaseLabelData, ThrowOnError>) => (options.client ?? client).post<PostEmailAddClaimcaseLabelResponses, PostEmailAddClaimcaseLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/AddClaimcaseLabel',
    ...options
});

export const postEmailAddNoClaimcaseLabel = <ThrowOnError extends boolean = true>(options: Options<PostEmailAddNoClaimcaseLabelData, ThrowOnError>) => (options.client ?? client).post<PostEmailAddNoClaimcaseLabelResponses, PostEmailAddNoClaimcaseLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/AddNoClaimcaseLabel',
    ...options
});

export const postEmailChangeClaimcaseLabel = <ThrowOnError extends boolean = true>(options: Options<PostEmailChangeClaimcaseLabelData, ThrowOnError>) => (options.client ?? client).post<PostEmailChangeClaimcaseLabelResponses, PostEmailChangeClaimcaseLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/ChangeClaimcaseLabel',
    ...options
});

export const postEmailCleanupOldClaimcases = <ThrowOnError extends boolean = true>(options: Options<PostEmailCleanupOldClaimcasesData, ThrowOnError>) => (options.client ?? client).post<PostEmailCleanupOldClaimcasesResponses, PostEmailCleanupOldClaimcasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/CleanupOldClaimcases',
    ...options
});

export const postEmailRemoveClaimcaseLabel = <ThrowOnError extends boolean = true>(options: Options<PostEmailRemoveClaimcaseLabelData, ThrowOnError>) => (options.client ?? client).post<PostEmailRemoveClaimcaseLabelResponses, PostEmailRemoveClaimcaseLabelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/RemoveClaimcaseLabel',
    ...options
});

export const postEmailSyncFull = <ThrowOnError extends boolean = true>(options?: Options<PostEmailSyncFullData, ThrowOnError>) => (options?.client ?? client).post<PostEmailSyncFullResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/Sync/Full',
    ...options
});

export const postEmailSyncClaimcase = <ThrowOnError extends boolean = true>(options: Options<PostEmailSyncClaimcaseData, ThrowOnError>) => (options.client ?? client).post<PostEmailSyncClaimcaseResponses, PostEmailSyncClaimcaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/SyncClaimcase',
    ...options
});

export const postEmailSyncUnlabeled = <ThrowOnError extends boolean = true>(options?: Options<PostEmailSyncUnlabeledData, ThrowOnError>) => (options?.client ?? client).post<PostEmailSyncUnlabeledResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Email/SyncUnlabeled',
    ...options
});

export const postFnolAddAttachment = <ThrowOnError extends boolean = true>(options?: Options<PostFnolAddAttachmentData, ThrowOnError>) => (options?.client ?? client).post<PostFnolAddAttachmentResponses, PostFnolAddAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/AddAttachment',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolComplete = <ThrowOnError extends boolean = true>(options?: Options<PostFnolCompleteData, ThrowOnError>) => (options?.client ?? client).post<PostFnolCompleteResponses, PostFnolCompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/Complete',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getFnolGet = <ThrowOnError extends boolean = true>(options: Options<GetFnolGetData, ThrowOnError>) => (options.client ?? client).get<GetFnolGetResponses, GetFnolGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/Get',
    ...options
});

export const getFnolGetReports = <ThrowOnError extends boolean = true>(options?: Options<GetFnolGetReportsData, ThrowOnError>) => (options?.client ?? client).get<GetFnolGetReportsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/GetReports',
    ...options
});

export const postFnolInit = <ThrowOnError extends boolean = true>(options?: Options<PostFnolInitData, ThrowOnError>) => (options?.client ?? client).post<PostFnolInitResponses, PostFnolInitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/Init',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolRemoveAttachment = <ThrowOnError extends boolean = true>(options?: Options<PostFnolRemoveAttachmentData, ThrowOnError>) => (options?.client ?? client).post<PostFnolRemoveAttachmentResponses, PostFnolRemoveAttachmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/RemoveAttachment',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetCustomEmail = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetCustomEmailData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetCustomEmailResponses, PostFnolSetCustomEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetCustomEmail',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetCustomPhoneNumber = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetCustomPhoneNumberData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetCustomPhoneNumberResponses, PostFnolSetCustomPhoneNumberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetCustomPhoneNumber',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetIncidentDay = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetIncidentDayData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetIncidentDayResponses, PostFnolSetIncidentDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetIncidentDay',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetInsuranceHolder = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetInsuranceHolderData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetInsuranceHolderResponses, PostFnolSetInsuranceHolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetInsuranceHolder',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetInsuredObject = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetInsuredObjectData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetInsuredObjectResponses, PostFnolSetInsuredObjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetInsuredObject',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postFnolSetVar = <ThrowOnError extends boolean = true>(options?: Options<PostFnolSetVarData, ThrowOnError>) => (options?.client ?? client).post<PostFnolSetVarResponses, PostFnolSetVarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Fnol/SetVar',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getGetAllQuestions = <ThrowOnError extends boolean = true>(options?: Options<GetGetAllQuestionsData, ThrowOnError>) => (options?.client ?? client).get<GetGetAllQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/GetAllQuestions',
    ...options
});

export const getGetAllTasks = <ThrowOnError extends boolean = true>(options?: Options<GetGetAllTasksData, ThrowOnError>) => (options?.client ?? client).get<GetGetAllTasksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/GetAllTasks',
    ...options
});

export const getGetInvoiceRecipients = <ThrowOnError extends boolean = true>(options?: Options<GetGetInvoiceRecipientsData, ThrowOnError>) => (options?.client ?? client).get<GetGetInvoiceRecipientsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/GetInvoiceRecipients',
    ...options
});

export const getGetUnlabeledEmails = <ThrowOnError extends boolean = true>(options?: Options<GetGetUnlabeledEmailsData, ThrowOnError>) => (options?.client ?? client).get<GetGetUnlabeledEmailsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/GetUnlabeledEmails',
    ...options
});

export const getGmailConnectLink = <ThrowOnError extends boolean = true>(options?: Options<GetGmailConnectLinkData, ThrowOnError>) => (options?.client ?? client).get<GetGmailConnectLinkResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Gmail/ConnectLink',
    ...options
});

export const postGmailDisconnect = <ThrowOnError extends boolean = true>(options?: Options<PostGmailDisconnectData, ThrowOnError>) => (options?.client ?? client).post<PostGmailDisconnectResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Gmail/Disconnect',
    ...options
});

export const getHealthCheck = <ThrowOnError extends boolean = true>(options?: Options<GetHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetHealthCheckResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/HealthCheck',
    ...options
});

export const getInboxRecentEmails = <ThrowOnError extends boolean = true>(options?: Options<GetInboxRecentEmailsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxRecentEmailsResponses, GetInboxRecentEmailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Inbox/RecentEmails',
    ...options
});

export const getInboxUnhandledEmails = <ThrowOnError extends boolean = true>(options?: Options<GetInboxUnhandledEmailsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxUnhandledEmailsResponses, GetInboxUnhandledEmailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Inbox/UnhandledEmails',
    ...options
});

export const getInfo = <ThrowOnError extends boolean = true>(options?: Options<GetInfoData, ThrowOnError>) => (options?.client ?? client).get<GetInfoResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Info',
    ...options
});

export const getPaymentGetFromOpenClaimcases = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentGetFromOpenClaimcasesData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentGetFromOpenClaimcasesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Payment/GetFromOpenClaimcases',
    ...options
});

export const getPaymentGetRejected = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentGetRejectedData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentGetRejectedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Payment/GetRejected',
    ...options
});

export const getPaymentGetScheduled = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentGetScheduledData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentGetScheduledResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Payment/GetScheduled',
    ...options
});

export const getPaymentGetUnsigned = <ThrowOnError extends boolean = true>(options?: Options<GetPaymentGetUnsignedData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentGetUnsignedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Payment/GetUnsigned',
    ...options
});

export const getPolicyByInsuranceHolderCompany = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuranceHolderCompanyData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuranceHolderCompanyResponses, GetPolicyByInsuranceHolderCompanyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuranceHolderCompany',
    ...options
});

export const getPolicyByInsuranceHolderCompanyDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuranceHolderCompanyDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuranceHolderCompanyDayResponses, GetPolicyByInsuranceHolderCompanyDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuranceHolderCompanyDay',
    ...options
});

export const getPolicyByInsuranceHolderPerson = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuranceHolderPersonData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuranceHolderPersonResponses, GetPolicyByInsuranceHolderPersonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuranceHolderPerson',
    ...options
});

export const getPolicyByInsuranceHolderPersonDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuranceHolderPersonDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuranceHolderPersonDayResponses, GetPolicyByInsuranceHolderPersonDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuranceHolderPersonDay',
    ...options
});

export const getPolicyByInsuredObjectCompany = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectCompanyData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectCompanyResponses, GetPolicyByInsuredObjectCompanyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectCompany',
    ...options
});

export const getPolicyByInsuredObjectCompanyDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectCompanyDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectCompanyDayResponses, GetPolicyByInsuredObjectCompanyDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectCompanyDay',
    ...options
});

export const getPolicyByInsuredObjectPerson = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectPersonData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectPersonResponses, GetPolicyByInsuredObjectPersonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectPerson',
    ...options
});

export const getPolicyByInsuredObjectPersonDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectPersonDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectPersonDayResponses, GetPolicyByInsuredObjectPersonDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectPersonDay',
    ...options
});

export const getPolicyByInsuredObjectVehicle = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectVehicleData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectVehicleResponses, GetPolicyByInsuredObjectVehicleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectVehicle',
    ...options
});

export const getPolicyByInsuredObjectVehicleDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByInsuredObjectVehicleDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByInsuredObjectVehicleDayResponses, GetPolicyByInsuredObjectVehicleDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByInsuredObjectVehicleDay',
    ...options
});

export const getPolicyByKey = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByKeyData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByKeyResponses, GetPolicyByKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByKey',
    ...options
});

export const getPolicyByKeyDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyByKeyDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyByKeyDayResponses, GetPolicyByKeyDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/ByKeyDay',
    ...options
});

export const getPolicyGetByNumberDay = <ThrowOnError extends boolean = true>(options: Options<GetPolicyGetByNumberDayData, ThrowOnError>) => (options.client ?? client).get<GetPolicyGetByNumberDayResponses, GetPolicyGetByNumberDayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Policy/GetByNumberDay',
    ...options
});

export const getReportBankTransaction = <ThrowOnError extends boolean = true>(options?: Options<GetReportBankTransactionData, ThrowOnError>) => (options?.client ?? client).get<GetReportBankTransactionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/BankTransaction',
    ...options
});

export const getReportClaimSummary = <ThrowOnError extends boolean = true>(options?: Options<GetReportClaimSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetReportClaimSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/ClaimSummary',
    ...options
});

export const getReportCoverQuestions = <ThrowOnError extends boolean = true>(options?: Options<GetReportCoverQuestionsData, ThrowOnError>) => (options?.client ?? client).get<GetReportCoverQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/CoverQuestions',
    ...options
});

export const getReportFullTransaction = <ThrowOnError extends boolean = true>(options: Options<GetReportFullTransactionData, ThrowOnError>) => (options.client ?? client).get<GetReportFullTransactionResponses, GetReportFullTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/FullTransaction',
    ...options
});

export const getReportKpi = <ThrowOnError extends boolean = true>(options: Options<GetReportKpiData, ThrowOnError>) => (options.client ?? client).get<GetReportKpiResponses, GetReportKpiErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/Kpi',
    ...options
});

export const getReportKpiList = <ThrowOnError extends boolean = true>(options?: Options<GetReportKpiListData, ThrowOnError>) => (options?.client ?? client).get<GetReportKpiListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/KpiList',
    ...options
});

export const postReportRecalculateKpis = <ThrowOnError extends boolean = true>(options?: Options<PostReportRecalculateKpisData, ThrowOnError>) => (options?.client ?? client).post<PostReportRecalculateKpisResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/RecalculateKpis',
    ...options
});

export const getReportScheduledPayments = <ThrowOnError extends boolean = true>(options?: Options<GetReportScheduledPaymentsData, ThrowOnError>) => (options?.client ?? client).get<GetReportScheduledPaymentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/ScheduledPayments',
    ...options
});

export const getReportSebTransactionGetTransactionList = <ThrowOnError extends boolean = true>(options: Options<GetReportSebTransactionGetTransactionListData, ThrowOnError>) => (options.client ?? client).get<GetReportSebTransactionGetTransactionListResponses, GetReportSebTransactionGetTransactionListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/SebTransaction/GetTransactionList',
    ...options
});

export const getReportSummary = <ThrowOnError extends boolean = true>(options?: Options<GetReportSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetReportSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/Summary',
    ...options
});

export const getReportTransaction = <ThrowOnError extends boolean = true>(options: Options<GetReportTransactionData, ThrowOnError>) => (options.client ?? client).get<GetReportTransactionResponses, GetReportTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Report/Transaction',
    ...options
});

export const postS3PresignGetPresignUrl = <ThrowOnError extends boolean = true>(options?: Options<PostS3PresignGetPresignUrlData, ThrowOnError>) => (options?.client ?? client).post<PostS3PresignGetPresignUrlResponses, PostS3PresignGetPresignUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/S3Presign/GetPresignUrl',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getSearchEmail = <ThrowOnError extends boolean = true>(options: Options<GetSearchEmailData, ThrowOnError>) => (options.client ?? client).get<GetSearchEmailResponses, GetSearchEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Search/Email',
    ...options
});

export const getSearchFreeText = <ThrowOnError extends boolean = true>(options: Options<GetSearchFreeTextData, ThrowOnError>) => (options.client ?? client).get<GetSearchFreeTextResponses, GetSearchFreeTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Search/FreeText',
    ...options
});

export const getSearchMatchingClaimcase = <ThrowOnError extends boolean = true>(options?: Options<GetSearchMatchingClaimcaseData, ThrowOnError>) => (options?.client ?? client).get<GetSearchMatchingClaimcaseResponses, GetSearchMatchingClaimcaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Search/MatchingClaimcase',
    ...options
});

export const getSearchPoliciesByInsuranceHolder = <ThrowOnError extends boolean = true>(options: Options<GetSearchPoliciesByInsuranceHolderData, ThrowOnError>) => (options.client ?? client).get<GetSearchPoliciesByInsuranceHolderResponses, GetSearchPoliciesByInsuranceHolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Search/PoliciesByInsuranceHolder',
    ...options
});

export const getSearchPoliciesByInsuredObject = <ThrowOnError extends boolean = true>(options: Options<GetSearchPoliciesByInsuredObjectData, ThrowOnError>) => (options.client ?? client).get<GetSearchPoliciesByInsuredObjectResponses, GetSearchPoliciesByInsuredObjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Search/PoliciesByInsuredObject',
    ...options
});

export const postSebIntegrationExportPain001Payments = <ThrowOnError extends boolean = true>(options?: Options<PostSebIntegrationExportPain001PaymentsData, ThrowOnError>) => (options?.client ?? client).post<PostSebIntegrationExportPain001PaymentsResponses, PostSebIntegrationExportPain001PaymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SebIntegration/ExportPain001Payments',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSebIntegrationExportPain001PaymentsBefore = <ThrowOnError extends boolean = true>(options?: Options<PostSebIntegrationExportPain001PaymentsBeforeData, ThrowOnError>) => (options?.client ?? client).post<PostSebIntegrationExportPain001PaymentsBeforeResponses, PostSebIntegrationExportPain001PaymentsBeforeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SebIntegration/ExportPain001PaymentsBefore',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSebIntegrationImportCamtTransaction = <ThrowOnError extends boolean = true>(options?: Options<PostSebIntegrationImportCamtTransactionData, ThrowOnError>) => (options?.client ?? client).post<PostSebIntegrationImportCamtTransactionResponses, PostSebIntegrationImportCamtTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SebIntegration/ImportCamtTransaction',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSebIntegrationImportPain002Report = <ThrowOnError extends boolean = true>(options?: Options<PostSebIntegrationImportPain002ReportData, ThrowOnError>) => (options?.client ?? client).post<PostSebIntegrationImportPain002ReportResponses, PostSebIntegrationImportPain002ReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SebIntegration/ImportPain002Report',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSendUnlabeledForward = <ThrowOnError extends boolean = true>(options?: Options<PostSendUnlabeledForwardData, ThrowOnError>) => (options?.client ?? client).post<PostSendUnlabeledForwardResponses, PostSendUnlabeledForwardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SendUnlabeledForward',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSendUnlabeledReply = <ThrowOnError extends boolean = true>(options?: Options<PostSendUnlabeledReplyData, ThrowOnError>) => (options?.client ?? client).post<PostSendUnlabeledReplyResponses, PostSendUnlabeledReplyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/SendUnlabeledReply',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getSkadehubInbox = <ThrowOnError extends boolean = true>(options: Options<GetSkadehubInboxData, ThrowOnError>) => (options.client ?? client).get<GetSkadehubInboxResponses, GetSkadehubInboxErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/Inbox',
    ...options
});

export const getSkadehubIncidentDetails = <ThrowOnError extends boolean = true>(options: Options<GetSkadehubIncidentDetailsData, ThrowOnError>) => (options.client ?? client).get<GetSkadehubIncidentDetailsResponses, GetSkadehubIncidentDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/IncidentDetails',
    ...options
});

export const getSkadehubIncidentLoginUrl = <ThrowOnError extends boolean = true>(options: Options<GetSkadehubIncidentLoginUrlData, ThrowOnError>) => (options.client ?? client).get<GetSkadehubIncidentLoginUrlResponses, GetSkadehubIncidentLoginUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/IncidentLoginUrl',
    ...options
});

export const postSkadehubPoll = <ThrowOnError extends boolean = true>(options?: Options<PostSkadehubPollData, ThrowOnError>) => (options?.client ?? client).post<PostSkadehubPollResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/Poll',
    ...options
});

export const postSkadehubSetIncidentStatus = <ThrowOnError extends boolean = true>(options?: Options<PostSkadehubSetIncidentStatusData, ThrowOnError>) => (options?.client ?? client).post<PostSkadehubSetIncidentStatusResponses, PostSkadehubSetIncidentStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/SetIncidentStatus',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getSkadehubSuggestedCases = <ThrowOnError extends boolean = true>(options: Options<GetSkadehubSuggestedCasesData, ThrowOnError>) => (options.client ?? client).get<GetSkadehubSuggestedCasesResponses, GetSkadehubSuggestedCasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/SuggestedCases',
    ...options
});

export const getSkadehubUnlinked = <ThrowOnError extends boolean = true>(options: Options<GetSkadehubUnlinkedData, ThrowOnError>) => (options.client ?? client).get<GetSkadehubUnlinkedResponses, GetSkadehubUnlinkedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Skadehub/Unlinked',
    ...options
});

export const postSuggestorsTestSuggestorClaimcaseSuggestions = <ThrowOnError extends boolean = true>(options: Options<PostSuggestorsTestSuggestorClaimcaseSuggestionsData, ThrowOnError>) => (options.client ?? client).post<PostSuggestorsTestSuggestorClaimcaseSuggestionsResponses, PostSuggestorsTestSuggestorClaimcaseSuggestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Suggestors/testSuggestor/claimcaseSuggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options.headers
    }
});

export const postSuggestorsTestSuggestorFeedback = <ThrowOnError extends boolean = true>(options?: Options<PostSuggestorsTestSuggestorFeedbackData, ThrowOnError>) => (options?.client ?? client).post<PostSuggestorsTestSuggestorFeedbackResponses, PostSuggestorsTestSuggestorFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Suggestors/testSuggestor/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSuggestorsTestSuggestorFnolSuggestions = <ThrowOnError extends boolean = true>(options?: Options<PostSuggestorsTestSuggestorFnolSuggestionsData, ThrowOnError>) => (options?.client ?? client).post<PostSuggestorsTestSuggestorFnolSuggestionsResponses, PostSuggestorsTestSuggestorFnolSuggestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Suggestors/testSuggestor/fnolSuggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const postSuggestorsTestSuggestorUnlabeledEmailSuggestions = <ThrowOnError extends boolean = true>(options?: Options<PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsData, ThrowOnError>) => (options?.client ?? client).post<PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsResponses, PostSuggestorsTestSuggestorUnlabeledEmailSuggestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/Suggestors/testSuggestor/unlabeledEmailSuggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        ...options?.headers
    }
});

export const getOauthCallbackByIntegration = <ThrowOnError extends boolean = true>(options: Options<GetOauthCallbackByIntegrationData, ThrowOnError>) => (options.client ?? client).get<GetOauthCallbackByIntegrationResponses, GetOauthCallbackByIntegrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/oauth_callback/{integration}',
    ...options
});
